import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ProfileImageGallery() {
  const [images, setImages] = useState([]);
  const [sliderGallery, setSliderGallery] = useState([]);
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("adminToken");
  const fileInputRef = useRef(null);

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setImages(selectedFiles);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!images.length) {
      toast.error("Please select at least one image!");
      return;
    }

    const formData = new FormData();
    images.forEach((file) => {
      formData.append("images", file);
    });
    formData.append("user_id", userId);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/gallery/add/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Photos uploaded successfully!");
      setImages([]);
      fileInputRef.current.value = "";
      getGalleryImages();
    } catch (error) {
      toast.error("Failed to upload photos: " + error.message);
      console.error("Upload error:", error);
    }
  };

  const getGalleryImages = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/gallery/getbyid/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSliderGallery(response.data.data || []);
    } catch (error) {
      toast.error("Failed to fetch gallery images");
      console.error("Fetch error:", error);
    }
  };

  const handleRemoveGalleryImage = async (imageId) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/gallery/delete/${imageId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Image removed successfully!");
      getGalleryImages();
    } catch (error) {
      toast.error("Failed to delete image");
      console.error("Delete error:", error);
    }
  };

  useEffect(() => {
    if (userId && token) {
      getGalleryImages();
    }
  }, [userId, token]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <section className="page-info-sec">
        <div
          className="bg-fixed"
          style={{ backgroundImage: "url('./img/inner_banner.png')" }}
        ></div>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col">
              <div className="page-info-block">
                <h1>Upload Gallery Photos</h1>
                <p>Upload Gallery Photos</p>
                <p className="page_nav">
                  <a href="/">Home</a>
                  <span className="mx-2">/</span>
                  <a href="#" className="currentPage">
                    Upload Gallery Photos
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="video-chat-form-sec secpd70">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mx-auto">
              <h3>Gallery Images:</h3>
              <div className="row">
                {sliderGallery.length > 0 ? (
                  sliderGallery.map((galleryData) => (
                    <div key={galleryData.id} className="col-md-3 my-2 position-relative">
                      <img
                        src={`${process.env.REACT_APP_API_URL}/${galleryData.image}`}
                        alt="Gallery"
                        className="img-fluid"
                        onError={(e) => {
                          e.target.src = "/fallback-image.jpg";
                        }}
                      />
                      <span
                        className="del_icon"
                        onClick={() => handleRemoveGalleryImage(galleryData.id)}
                        role="button"
                        aria-label="Delete image"
                      >
                        X
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center">
                    <p>No images in gallery</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mx-auto">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="mb-3">
                  <label htmlFor="images" className="form-label mb-2">
                    Upload Photos:
                  </label>
                  <input
                    type="file"
                    name="images"
                    id="images"
                    className="form-control"
                    multiple
                    accept="image/*"
                    onChange={handleFileUpload}
                    ref={fileInputRef}
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary my-3"
                  disabled={!images.length}
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProfileImageGallery;